import React from 'react';
export { BackendAdd } from './Add';
export { BackendEdit } from './Edit';

export const Backends: React.FC = () => {
    return null;
};
